export default "/_next/static/images/filter1-a7f59350dffa043bc3e31cac8beae1e6.gif";